import React, { useEffect } from "react";


function Ebuero() {

    useEffect(() => {
        // localStorage.setItem("access_token", "e6a36d27-a534-43fc-a46b-be234e00012e");
        //  console.log(localStorage.getItem("access_token"));
        // Example of setting a cookie
        //  document.cookie = "username=Sam Doe;SameSite=None;Secure";
        // document.cookie = "access_token=e6a36d27-a534-43fc-a46b-be234e00012e;SameSite=None;Secure";
        //document.cookie = "device_id=123232323232;SameSite=None;Secure";
        //document.cookie = "device_ids=123232323232;SameSite=None";
        //document.cookie = "access_tokenxxx=e6a36d27-a534-43fc-a46b-be234e00012e;expires=Session;SameSite=Lax;domain=.ebuero.de";
        //document.cookie = "cookieName=cookieValue;Secure;SameSite=Lax";
        // window.location.replace('https://portal.ebuero.de');
        // window.location.replace('https://sugarcrm.tsrv.ebuero.de');

    }, []);
    return null;
}

export default Ebuero;
